// src/composables/useSocket.js
import { ref } from 'vue';
import { io } from 'socket.io-client';
import { Local } from '@/utils/storage';

const SOCKET_SERVER_URL = process.env.VUE_APP_CHAT_URL;

export function useSocket() {
  const isConnected = ref(false);
  let socket:any = null;

  const connect = () => {
    let mechanism = Local.get("current_mechanism")
    if(!mechanism.id){
        return
    }
    if (socket) return; // 防止重复连接

    socket = io(SOCKET_SERVER_URL, {
      autoConnect: true,
      transports: ['websocket'],
      query: {user_id: 'm' + mechanism.id}
    });

    socket.on('connect', () => {
      isConnected.value = true;
    });

    socket.on('disconnect', () => {
      isConnected.value = false;
    });
    
    // 可以在这里统一处理一些全局事件
  };

  const disconnect = () => {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  };

  const emit = (eventName:string, data:any) => {
    if (socket && isConnected.value) {
      socket.emit(eventName, data);
    }
  };

  const on = (eventName:string, callback:any) => {
    if (socket) {
      socket.on(eventName, callback);
    }
  };
  
  const off = (eventName:string, callback:any) => {
    if (socket) {
      socket.off(eventName, callback);
    }
  };


  return {
    isConnected,
    connect,
    disconnect,
    emit,
    on,
    off,
  };
}